import script from "./DuplicateProductModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DuplicateProductModal.vue?vue&type=script&lang=ts&setup=true"

import "./DuplicateProductModal.vue?vue&type=style&index=0&id=607c2c4a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607c2c4a"]])

export default __exports__